import LoadingSkeleton from "./loading_skeleton.tsx";
import { SecondaryBody } from "@sprout/typography.tsx";

import PreviewIcon from "@sprout/icons/preview.tsx";
import { useMemo, useState } from "react";
import useTranslation from "@hooks/use_translation.ts";
import { differenceInCalendarDays } from "date-fns";
import { SecondaryButtonLink } from "@sprout/buttons";

type Props = {
  loading?: boolean;
  publishedAt: string;
  url: string;
};
const ResultLogo = ({ loading, publishedAt, url }: Props) => {
  const { t } = useTranslation("jobSearch");
  const [previewIconColor, setPreviewIconColor] = useState("green");

  const timeSincePublished = useMemo((): string | null => {
    const datePublished = Date.parse(publishedAt);

    if (isNaN(datePublished)) {
      return "";
    }

    const daysSince = differenceInCalendarDays(new Date(), datePublished);
    if (daysSince < 7) {
      return t("publishedDaysAgo", { count: daysSince });
    }

    const weeksSince = Math.floor(daysSince / 7);
    return t("publishedWeeksAgo", { count: weeksSince });
  }, [publishedAt, t]);

  return loading ? (
    <LoadingSkeleton className="h-4 w-[80px]" />
  ) : (
    <>
      <SecondaryBody>{timeSincePublished}</SecondaryBody>
      <SecondaryButtonLink
        href={url}
        external={true}
        size="medium"
        onMouseEnter={() => setPreviewIconColor("dark-green")}
        onMouseLeave={() => setPreviewIconColor("green")}
      >
        <div className="flex flex-row gap-1 items-center justify-between">
          {t("viewJob")}
          <PreviewIcon color={previewIconColor} size="sm" />
        </div>
      </SecondaryButtonLink>
    </>
  );
};

export default ResultLogo;
